"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base64URLEncode = base64URLEncode;
exports.sha256 = sha256;

var _crypto = _interopRequireDefault(require("crypto"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function base64URLEncode(str) {
  return str.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
} // var verifier = base64URLEncode(crypto.randomBytes(32));


function sha256(buffer) {
  return _crypto.default.createHash('sha256').update(buffer).digest();
} // var challenge = base64URLEncode(sha256(verifier));